import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import {
  AdproductsMoodysReportType,
  type CustomerAnalyticsMoodysAskingRentVacancyDto,
  type CustomerAnalyticsMoodysReportDto,
} from '@zg-rentals/ts-customer-analytics-client';
import { Label } from 'recharts';
import { renderChartToPdf } from './pdfImageUtils';

interface RentTrendsChartProps {
  report: CustomerAnalyticsMoodysReportDto;
}

const RentTrendsChart = ({ report }: RentTrendsChartProps) => {
  const hasSubmarketData = report.reportType === AdproductsMoodysReportType.SUBMARKET;
  const currentYear = new Date().getFullYear();
  const maxYearsInPast = 10;
  const maxYearsInFuture = 0;
  const yearFilter = (item: CustomerAnalyticsMoodysAskingRentVacancyDto) =>
    currentYear - maxYearsInPast <= item.year && item.year <= currentYear + maxYearsInFuture;

  const submarketData = report.askingRentVacancyTrendsReport.submarket;
  const marketData = report.askingRentVacancyTrendsReport.market;

  const data = marketData
    .filter(yearFilter)
    .sort((a, b) => a.year - b.year)
    .map((item) => ({
      name: item.year,
      marketRent: item.askingRent,
      submarketRent: submarketData?.find((marketReport) => marketReport.year === item.year)?.askingRent,
    }));

  return (
    <BarChart
      width={1400}
      height={500}
      data={data}
      margin={{
        top: 10,
        right: 5,
        left: 20,
        bottom: 30,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis>
        <Label
          value="Asking rent per unit ($)"
          offset={-8}
          angle={-90}
          position="insideLeft"
          style={{ textAnchor: 'middle', fontSize: '30px' }}
        />
      </YAxis>
      <Legend wrapperStyle={{ position: 'relative', fontSize: '30px', marginTop: '-15px', fontFamily: 'sans-serif' }} />
      {hasSubmarketData && (
        <Bar
          barSize={20}
          isAnimationActive={false}
          dataKey="submarketRent"
          fill="#001851"
          name={report.submarketName}
        />
      )}
      <Bar
        barSize={20}
        isAnimationActive={false}
        dataKey="marketRent"
        fill={hasSubmarketData ? '#b7b7b7' : '#001851'}
        name={report.marketName}
      />
    </BarChart>
  );
};

export const renderRentTrendsChart = async (report: CustomerAnalyticsMoodysReportDto): Promise<string> => {
  return await renderChartToPdf(<RentTrendsChart report={report} />);
};
